import { Injectable } from '@angular/core';
import { ICmsDirective } from '@icms/client/assets/text/icms.directive';
import { ICmsCoreIntegrationAbstractService } from './icms-core-integration-abstract.service';

@Injectable({ providedIn: 'root' })
export class ICmsCoreIntegrationDirectiveService extends ICmsCoreIntegrationAbstractService<ICmsDirective> {}
